/**
 * Service 基类
 * 提供通用的服务功能和错误处理
 * @module core/services/BaseService
 */

import type { HttpClient } from '../http/HttpClient'
import type { IStorage } from '../storage/Storage'

export abstract class BaseService {
  protected http: HttpClient
  protected storage: IStorage

  constructor(http: HttpClient, storage: IStorage) {
    this.http = http
    this.storage = storage
  }

  /**
   * 处理错误
   * @param error - 错误对象
   * @param context - 错误上下文描述
   * @throws 始终抛出错误
   */
  protected handleError(error: unknown, context: string): never {
    console.error(`[${this.constructor.name}] ${context}:`, error)
    throw error
  }
}
